import HeroSection from "./home/HeroSection";
import "../styles/Home.css";

export default function Home() {
  return (
    <>
      <HeroSection />
    </>
  );
}
